module.exports = __webpack_public_path__ + "img/ex3.684d544f.jpg";